import { ref, watch } from "vue";
import Render from "../../woocommerce/render";

export const useHandleAddToCart = (productData, basket, product_id) => {
	const isAddingToBasket = ref(false);
	const successNotification = ref("");

	const addToBasket = () => {
		const validationStatus = useValidation();
		if (validationStatus) return;

		isAddingToBasket.value = true;

		const variations = [];
		basket.value.products.map((product) => {
			product.products.map((product) => {
				variations.push({
					variation_id: product.variation_id,
					quantity: product.qty,
				});
			});
		});

		const personalisation = [];

		basket.value.personalisation.map((data) => {
			if (!data.location && !data.type && !data.numberOfColours && !data.logo) {
				return;
			}

			personalisation.push({
				location: data.location,
				type: data.type,
				colour: data.numberOfColours,
				logo: data.logo,
				price_per_item: data.price_per_item,
				setup: data.setup,
			});
		});

		const postData = {
			product_id: product_id,
			variations,
			personalisation,
			comments: basket.value.comments,
		};

		const data = fetch("/wp-json/product-builder/v1/add-to-basket", {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(postData),
		}).then(() => {
			isAddingToBasket.value = false;
			successNotification.value = "Product added to basket";
			new Render();
			document.body.scrollTop = document.documentElement.scrollTop = 200;
			basket.value.products.splice(0);
			basket.value.personalisation.splice(0, basket.value.personalisation.length, {
				logo: null,
				location: "",
				type: "",
				numberOfColours: "",
				large: false,
				setup: 0.0,
				price_type: "",
				error: "",
				price_per_item: 0.0,
			});
			basket.value.comments = "";
			basket.value.total = 0.0;
		});
	};

	const useValidation = () => {
		let errorInPersonalisation = false;

		if (productData.value.personalisation) {
			basket.value.personalisation.map((personalisation) => {
				if (
					!personalisation.location &&
					!personalisation.type &&
					!personalisation.numberOfColours
				) {
					return;
				}

				if (!personalisation.location) {
					personalisation.error = "Please select a location";
				} else if (!personalisation.type) {
					personalisation.error = "Please select a type";
				} else if (!personalisation.numberOfColours) {
					personalisation.error =
						"Please select the number of colours in your logo";
				} else {
					personalisation.error = "";
				}

				if (personalisation.error) {
					errorInPersonalisation = true;
				}
			});
		}

		return errorInPersonalisation;
	};

	watch(successNotification, () => {
		if (!successNotification.value) return;
		setTimeout(() => {
			successNotification.value = "";
		}, 5000);
	});

	return {
		addToBasket,
		isAddingToBasket,
		successNotification,
	};
};
